export default "/images/preview_bf_billboard.webp?11fe4c83d4badf40054147c4429f7da8";